import common_translations from "../common.json";
import activities from "./activities.json";
import apac from "./apac.translation.json";
import app from "./app.json";
import blue from "./blue.translation.json";
import bootstrap from "./bootstrap.translation.json";
import cars from "./cars.json";
import checkout from "./checkout.json";
import commbankAu from "./commbank-au.translation.json";
import exchange from "./exchange.json";
import fintech from "./fintech.json";
import flights from "./flights.json";
import hopper from "./hopper.translation.json";
import hotels from "./hotels.json";
import hsbcIn from "./hsbc-in.translation.json";
import hsbcQa from "./hsbc-qa.translation.json";
import hsbcSg from "./hsbc-sg.translation.json";
import hsbcUae from "./hsbc-uae.translation.json";
import hyatt from "./hyatt.translation.json";
import lloyds from "./lloyds.translation.json";
import lotte_provided from "./lotte.provided.json";
import lotte from "./lotte.translation.json";
import marriott_provided from "./marriott.provided.json";
import marriott from "./marriott.translation.json";
import nubank_provided from "./nubank.provided.json";
import nubank from "./nubank.translation.json";
import packages from "./packages.json";
import perkspot from "./perkspot.translation.json";
import rbc from "./rbc.translation.json";
import selfServe from "./self-serve.json";
import smcc from "./smcc.translation.json";
import travelWishlists from "./travel-wishlists.json";
import traveler from "./traveler.json";
import tripadvisor from "./tripadvisor.translation.json";
import trips from "./trips.json";
import uber from "./uber.translation.json";
import ui from "./ui.json";
import virginAu from "./virgin-au.translation.json";
import wallet from "./wallet.json";

const bundle = {
  ...common_translations,
  ...app,
  ...flights,
  ...hotels,
  ...cars,
  ...ui,
  ...checkout,
  ...selfServe,
  ...trips,
  ...fintech,
  ...exchange,
  ...wallet,
  ...packages,
  ...traveler,
  ...travelWishlists,
  ...activities,
};

export default bundle;

export const en_defaultTranslations = bundle;

export const en_uberTranslations = uber;

export const en_hopperTranslations = hopper;

export const en_commbankAuTranslations = commbankAu;

export const en_hsbcInTranslations = hsbcIn;

export const en_hsbcSgTranslations = hsbcSg;

export const en_hsbcQaTranslations = hsbcQa;

export const en_hsbcUaeTranslations = hsbcUae;

export const en_smccTranslations = smcc;

export const en_tripadvisorTranslations = tripadvisor;

export const en_hyattTranslations = hyatt;

export const en_marriottTranslations = marriott;

export const en_lloydsTranslations = lloyds;

export const en_blueTranslations = blue;

export const en_bootstrapTranslations = bootstrap;

export const en_virginAuTranslations = virginAu;

export const en_nubankTranslations = nubank;

export const en_nubankProvidedTranslations = nubank_provided;

export const en_apacTranslations = apac;

export const en_lotteTranslations = lotte;

export const en_LotteProvidedTranslations = lotte_provided;

export const en_marriottProvidedTranslations = marriott_provided;

export const en_perkspotTranslations = perkspot;

export const en_rbcTranslations = rbc;

export const en_checkoutTranslations = checkout;

export const en_activitiesTranslations = activities;
